import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "./Reveal";
import { CONTACT } from "@/lib/content";

const LINKS = [
  ["services", "Services"],
  ["process", "Process"],
  ["book", "Book"],
  ["contact", "Contact"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#0B0F17]/70 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-link-${id}`} className="group relative text-sm text-slate-300 transition-colors hover:text-white">
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-amber-300 transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={CONTACT.phoneHref} data-testid="nav-call-btn" className="hidden h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:border-amber-300 hover:text-amber-300 sm:flex" aria-label="Call us">
            <Phone className="h-4 w-4" />
          </a>
          <motion.button whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.96 }} onClick={() => go("book")} data-testid="nav-book-btn" className="hidden rounded-full bg-amber-400 px-5 py-2.5 text-sm font-semibold text-[#0B0F17] transition-colors hover:bg-amber-300 sm:block">
            Book a clean
          </motion.button>
          <button onClick={() => setOpen((o) => !o)} data-testid="nav-mobile-toggle" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white md:hidden" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden border-t border-white/5 bg-[#0B0F17] md:hidden" data-testid="nav-mobile-menu">
            <div className="flex flex-col gap-1 px-5 py-4">
              {LINKS.map(([id, label]) => (
                <button key={id} onClick={() => go(id)} data-testid={`nav-mobile-link-${id}`} className="py-3 text-left font-display text-2xl font-bold text-white">
                  {label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
